export default __webpack_public_path__ + "static/media/detail-1.eac3bfdb.png";